import React, { useEffect, useState } from 'react'
import { Form, Switch } from 'antd'
import { useSelector } from 'react-redux'
import { isAdmin } from 'utils'
import './index.styl'
const { Item } = Form

const Buttons = ({ form, currentEventDetails }) => {
  const { user } = useSelector(state => state.session)
  const [donationTicketBool, setDonationTicketBool] = useState(currentEventDetails?.donationEnabled || false)
  const [showTLHomePage, setShowTLHomePage] = useState(currentEventDetails?.isShowTLHomePage ?? true)
  useEffect(() => {
    if (currentEventDetails) {
      setDonationTicketBool(currentEventDetails?.donationEnabled)
      form.setFieldsValue({
        donationEnabled: currentEventDetails?.donationEnabled,
      })
      setShowTLHomePage(currentEventDetails?.isShowTLHomePage ?? true)
      form.setFieldsValue({
        isShowTLHomePage: currentEventDetails?.isShowTLHomePage ?? true,
      })
    }
  }, [currentEventDetails, form])

  const donationTicketHandler = () => {
    setDonationTicketBool(!donationTicketBool)
    form.setFieldsValue({
      donationEnabled: !donationTicketBool,
    })
  }
  const showTLHomePageHandler = value => {
    setShowTLHomePage(value)
    form.setFieldsValue({
      isShowTLHomePage: value,
    })
  }
  return (
    <div className='buttonsWrapper'>
      <div className='switchButtonsWrapper'>
        <div className='switchWrapper'>
          <Item
            name='donationEnabled'
            valuePropName='checked'
            className=''
          >
            <Switch className='donationSwitch' onChange={donationTicketHandler} defaultChecked={donationTicketBool} />
          </Item>
          <div className='text'>Add Donation Ticket</div>
        </div>
        {isAdmin(user?.role) && (
          <div className='switchWrapper'>
            <Item
              name='isShowTLHomePage'
              valuePropName='checked'
              className=''
              initialValue={showTLHomePage}
            >
              <Switch className='donationSwitch' onChange={showTLHomePageHandler} defaultChecked={showTLHomePage} />
            </Item>
            <div className='text'>Show tickets on TL Home Page</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Buttons
